module.exports = __webpack_public_path__ + "img/dzjy2.a28d0028.jpg";